import React from 'react';
import { ToastType } from './interfaces';

export interface IToastContext {
  showToast(
    content: React.ReactNode,
    options?: {
      type: ToastType;
    },
  ): void;
}

export const ToastContext = React.createContext<IToastContext>({
  showToast: null,
});

export function useToast(): IToastContext {
  return React.useContext(ToastContext);
}

export const ToastContextConsumer = ToastContext.Consumer;
